// extracted by mini-css-extract-plugin
module.exports = {"container":"_3dszPSa5bjlUoC6mNAoQXm","content":"Z98Jhm49yYEgjL3XX7kFi","title":"_2lSONy1aYFNAFSSdt2d8HQ","subTitle":"_2Lbwg-Ipv7XlZAtblrOkde"};